<template>
  <div class="container-fluid">
    <div class="content-wrap-small content-pad">
      <div class="text-md-center mb-4 mb-md-5">
        <h2>
          {{ $t('loginPage.headline.general') }}
        </h2>
        <p>
          {{ $t('loginPage.headline.subHeadline') }}<br>
          {{ $t('loginPage.subHeadline') }}
        </p>
      </div>
      <dx-login
        :invitation-token="$route.query.invitationToken"
        :lawyer-invitation-token="$route.query.lawyerInvitationToken"
        class="pb-5"
      />
    </div>
  </div>
</template>

<script>
import DxLogin from '~/domains/authentication/components/DX-Login'
import loginFakerMixin from '~/javascripts/mixins/loginFakerMixin'
import apolloErrorsMixin from '~/javascripts/mixins/apolloErrorsMixin'
import { RESET_STORE } from '~/domains/application/__store__/actions'

export default {
  name: 'SelfServiceLogin',
  meta: {
    isPublic: true,
  },
  components: {
    DxLogin,
  },
  mixins: [
    loginFakerMixin,
    apolloErrorsMixin,
  ],
  data() {
    return {
      env: process.env.DEXTRA_ENV,
    }
  },
  nuxtI18n: {
    paths: {
      de: '/login',
      fr: '/connexion',
      it: '/accesso',
    },
  },
  mounted() {
    const {
      logout,
      reason,
    } = this.$route.query

    if (logout) {
      this.$store.dispatch(RESET_STORE)
      this.$apolloProvider.defaultClient.resetStore()
      switch (reason) {
        case 'sessionExpired':
          this.$notification.error({ messageKey: 'loginPage.errors.sessionExpired' })
          break
        case 'loginError':
          this.$notification.error({ messageKey: 'loginPage.error' })
          break
        default:
          break
      }
    }

    this.setupLoginFaker()
    if (this.$route.query.token) {
      this.setToken(this.$route.query.token)
    }
  },
}
</script>
